export { default } from './useRootNavigation';
export * from './useRootNavigation';
